import { Card, CardContent } from '@mui/material'
import React from 'react'
import HighchartsChart from '@/components/Charts/HighchartsChart'

const colors = [
    '#7cb5ec',
    '#434348',
    '#90ed7d',
    '#f7a35c',
    '#8085e9',
    '#f15c80',
    '#e4d354',
    '#2b908f',
    '#f45b5b',
    '#91e8e1',
    '#f45b5b',
    '#1f78b4',
    '#33a02c',
    '#e31a1c',
    '#ff7f00',
    '#6a3d9a',
    '#b15928',
    '#a6cee3',
    '#b2df8a',
    '#fb9a99',
    '#fdbf6f',
]
const symbols = ['circle', 'square', 'diamond', 'triangle', 'triangle-down']

const Legend = ({ series }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '10px' }}>
            {series.map((s, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', margin: '3px 10px' }}>
                    <div
                        style={{
                            width: '8px',
                            height: '8px',
                            backgroundColor: s.color,
                            marginRight: '5px',
                            clipPath: getSymbolClipPath(s.marker.symbol),
                        }}
                    ></div>
                    <span style={{ fontSize: '8px' }}>{s.name}</span>
                </div>
            ))}
        </div>
    )
}

const getSymbolClipPath = (symbol) => {
    switch (symbol) {
        case 'circle':
            return 'circle(50%)'
        case 'square':
            return 'none'
        case 'diamond':
            return 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)'
        case 'triangle':
            return 'polygon(50% 0%, 0% 100%, 100% 100%)'
        case 'triangle-down':
            return 'polygon(50% 100%, 0% 0%, 100% 0%)'
        default:
            return 'none'
    }
}

export const ScatterComponent = ({ hotels }) => {
    const computeSeries = () => {
        let categories = hotels
            ?.map((hotel) => hotel?.fund)
            ?.filter((value, index, self) => self.indexOf(value) === index)
        return categories?.map((category, index) => {
            return {
                name: category,
                data: hotels
                    ?.filter((hotel) => hotel?.fund === category)
                    ?.map((hotel) => {
                        return {
                            x: hotel?.surface,
                            y: hotel?.series
                                ?.filter((el) => el?.type === 'energy')
                                ?.map((el) => el?.data)
                                ?.map((el) => el?.reduce((a, b) => a + b?.value, 0))
                                ?.reduce((a, b) => a + b, 0),
                            id: hotel?.id,
                        }
                    }),
                color: colors[index % colors.length], // Assign color
                marker: {
                    symbol: symbols[index % symbols.length], // Assign symbol
                },
            }
        })
    }

    const series = computeSeries()

    return (
        <Card style={{ height: 450 }}>
            <CardContent style={{ position: 'relative' }}>
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                    }}
                >
                    Consommation
                </div>
                <br />
                <HighchartsChart
                    options={{
                        chart: {
                            type: 'scatter',
                            height: 300,
                        },
                        legend: {
                            enabled: false, // Disable the default legend
                        },
                        title: {
                            text: '',
                            enabled: false,
                        },
                        yAxis: [
                            {
                                title: {
                                    text: 'Consumption (kWh)',
                                },
                            },
                        ],
                        xAxis: [
                            {
                                title: {
                                    text: 'Surface (sq m)',
                                },
                            },
                        ],
                        series: series,

                        plotOptions: {
                            scatter: {
                                marker: {
                                    radius: 5, // Customize marker size
                                    states: {
                                        hover: {
                                            enabled: true,
                                            lineColor: 'rgb(100,100,100)',
                                        },
                                    },
                                },
                                states: {
                                    hover: {
                                        marker: {
                                            enabled: false,
                                        },
                                    },
                                },
                                tooltip: {
                                    headerFormat: '<b>{series.name}</b><br>',
                                    pointFormat: '{point.x} sq m, {point.y} kWh',
                                },
                            },
                        },
                    }}
                />

                <Legend series={series} />
            </CardContent>
        </Card>
    )
}

export default ScatterComponent
